import React from 'react';
import axios from 'axios';
import debounce from 'lodash/debounce';

import { withTranslation } from 'react-i18next';
import { searchMatchedTextValue } from '../../utils/common';
import ModalHeader from './commons/modalHeader';
import ModalSearchFilter from './commons/modalSearchFilter';
import ModalContent from './commons/modalContent';
import ModalFooter from './commons/modalFooter';
import RowItems from './commons/rowItems';
import Modal from '../../styled-base/modal';
import ImgIconComp from '../imgcomp';
import { uniqueArrayObject } from '../../utils/function';
import UserServices from '../../services/user.services';

const { CancelToken } = axios;
const LoaderComp = function (props) {
  return (
    <div className="loading-comp">
      <ImgIconComp id="loadinggif" />
    </div>
  );
};

const SEARCH_OKR_URL = 'goal/searchOKRresults';
const SEARCH_KR_URL = 'goal/searchKRresults';
const SEARCH_AI_URL = 'search/activity';
const SEARCH_WS_URL = 'search/workstream';
const RELATED_WORK_TITLE = 'related-work-title';

class AddITemModal extends React.Component {
  constructor(props) {
    super(props);
    let includedItems = this.props.items;
    if (this.props.excludedItems && includedItems) {
      includedItems = includedItems.filter((item) => !this.props.excludedItems.includes(item.id));
    }
    this.state = {
      items: includedItems || [],
      searchText: '',
      closedKr: false,
      selectedItems: [],
      pagination: false,
      totalCount: this.props.totalCount || 0,
      icon_loading: false,
      includeGreenGoals: false,
      includeArchivedKpis: false,
      aiType: this.props.aiType ?? null,
      errormsg: false,
      dataLoading: false,
      isSaving: false,
      disableFocusLock: false,
      searchByTagKRIds: [],
    };
    this.rowItem = this.rowItem.bind(this);
    this.toggleChkBox = this.toggleChkBox.bind(this);
    this.search = this.search.bind(this);
    this.filteredData = this.filteredData.bind(this);
    this.addItem = this.addItem.bind(this);
    this.invertGoals = this.invertGoals.bind(this);
    this.cancelRequest = null;
    this.delayedCallback = debounce(this.callAiSearchApi, 300);
    this.callAiSearchApi = this.callAiSearchApi.bind(this);
    this.loadMoreSearchResults = this.loadMoreSearchResults.bind(this);
    this.handleGreenGoals = this.handleGreenGoals.bind(this);
    this.handleArchivedKpis = this.handleArchivedKpis.bind(this);
    this.appendItemToState = this.appendItemToState.bind(this);
    this.userServices = new UserServices();
  }

  componentDidMount() {
    // register event for sync wobo object callback
    const type = this.props.id;
    if (type == 'ai' || type == 'objective' || type == 'key_result' || type == 'workstream' || type == 'kpi') {
      this.refs.scrollDivSection.addEventListener('scroll', () => {
        if (
          this.refs.scrollDivSection.scrollTop + this.refs.scrollDivSection.clientHeight >=
          this.refs.scrollDivSection.scrollHeight
        ) {
          // if(type == 'ai'){
          //     this.loadMoreSearchResults();
          // }else{
          this.loadMoreResults();
          // }
        }
      });
    }

    // disable background scrolling
    this.disableScroll();

    // Event Listeners and focus for a11y
    window.addEventListener('keydown', this.keyDownHandler, true);
    window.addEventListener('click', this.handleClickOutside, true);
    $('#add-item-modal-objective-kr').focus();
  }

  componentDidUpdate(prevProps) {
    let prevLength = prevProps.items && prevProps.items.length;
    if (!prevLength) {
      prevLength = 0;
    }
    if (this.props.items && this.props.items.length !== prevLength) {
      let items = this.props.items || [];
      if (this.props.excludedItems) {
        items = items.filter((item) => !this.props.excludedItems.includes(item.id));
      }
      this.setState({
        items,
      });
    }
  }

  componentWillUnmount() {
    this.enableScroll();
    window.removeEventListener('keydown', this.keyDownHandler, true);
    window.removeEventListener('click', this.handleClickOutside, true);
  }

  disableScroll() {
    // Get the current scroll position
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

    // if any scroll is attempted, set this to the previous value
    window.onscroll = function () {
      window.scrollTo(scrollLeft, scrollTop);
    };
  }

  keyDownHandler = (e) => {
    const parentEl = $('#add-item-modal-objective-kr');
    const isNode = $(e.target).closest(parentEl).length;
    if (isNode) {
      if (e.key === 'Escape') {
        this.props.closePopup();
      }
    }
  };

  handleClickOutside = (e) => {
    const parentEl = $('#add-item-modal-objective-kr');
    const isNode = $(e.target).closest(parentEl).length;
    if (!isNode) {
      $('#add-item-modal-objective-kr').focus();
    }
  };

  handleFocusLock = (disabled) => {
    if (this.props.focusLock) {
      this.setState({
        disableFocusLock: disabled,
      });
      if (disabled) {
        window.removeEventListener('click', this.handleClickOutside, true);
      } else {
        const el = $('#add-new-item-btn');
        setTimeout(() => {
          if (el) el.focus();
        }, 0);
        window.addEventListener('click', this.handleClickOutside, true);
      }
    }
  };

  enableScroll() {
    window.onscroll = () => {};
  }

  loadMoreResults = () => {
    // :Lazyloading for Objectives, keyresults and workstream
    // Prevent duplicate calls if already loading
    if (this.state.dataLoading) {
      return;
    }
    this.setState(
      {
        dataLoading: true,
        pagination: true,
      },
      () => {
        this.callAiSearchApi(true);
      },
    );
  };

  loadMoreSearchResults() {
    const { searchText } = this.state;
    if (searchText) {
      this.setState(
        {
          dataLoading: true,
          pagination: true,
        },
        () => {
          this.delayedCallback();
        },
      );
    }
  }

  rowItem(items) {
    return (
      <RowItems
        id={this.props.id}
        items={items}
        toggleChkBox={this.toggleChkBox}
        selectedItems={this.state.selectedItems}
        searchVal={this.state.searchText}
      />
    );
  }

  toggleChkBox(e, item) {
    const updateItem = {};
    // console.log('item', item)
    const { searchByTag = false } = item;
    let { selectedItems } = this.state;
    if (!selectedItems.includes(item.id)) {
      if (this.props.forSubAI) {
        this.setState({
          selectedItems: [],
        });
        selectedItems = [];
        selectedItems = selectedItems.concat(item.id);
      } else {
        selectedItems = selectedItems.concat(item.id);
      }
    } else {
      selectedItems = selectedItems.filter((i) => i != item.id);
    }
    updateItem.selectedItems = [...new Set(selectedItems)];
    if (searchByTag) {
      const { searchByTagKRIds = [] } = this.state;
      // console.log('searchByTagKRIds', searchByTagKRIds)
      updateItem.searchByTagKRIds = searchByTagKRIds.concat(item.id);
      // console.log('updateItem', updateItem)
    }
    updateItem.errormsg = false;
    this.setState(updateItem);
  }

  search(e) {
    const type = this.props.id;
    const val = e.target.value;
    let { items } = this.props;
    this.setState(
      {
        searchText: val,
        pagination: false,
        icon_loading: true,
        errormsg: false,
      },
      () => {
        if (type == 'key_result' || type == 'ai' || type == 'objective' || type == 'workstream' || type == 'kpi') {
          if (val) {
            this.delayedCallback();
            // this.setState({
            //     icon_loading:false
            // })
          } else {
            if (this.props.excludedItems) {
              items = items.filter((item) => !this.props.excludedItems.includes(item.id));
            }
            this.setState({
              items,
              totalCount: 0,
              icon_loading: false,
            });
            this.callAiSearchApi(true);
          }
        } else if (type == 'last_meeting_actions' && val != '') {
          const jsonString = JSON.stringify(this.props.items || []);
          const jsonObj = JSON.parse(jsonString);
          const items = jsonObj.filter(this.filteredData);
          this.setState({
            items,
            icon_loading: false,
          });
        }
      },
    );
  }

  callAiSearchApi(triggerBackEnd = false) {
    const type = this.props.id;
    const { fromHotbox = 0, forSubAI = false, tagId = '', parent = '', actId = '' } = this.props;
    const query = {};
    query.q = this.state.searchText;
    let props_items = this.props.items || [];
    if (this.props.excludedItems) {
      props_items = props_items.filter((item) => !this.props.excludedItems.includes(item.id));
    }
    const pageLimit = 50;
    let url = '';
    if (type == 'objective') {
      url = SEARCH_OKR_URL;
    } else if (type == 'key_result') {
      url = SEARCH_KR_URL;
    } else if (type == 'workstream') {
      url = SEARCH_WS_URL;
    } else if (type == 'kpi') {
      // For KPIs, use the same GraphQL search as the wizard (ui-search)
      const term = this.state.searchText || '';
      const termFilters = [];
      const pageLimitForKpi = pageLimit;

      // Handle pagination: GraphQL uses 0-based page numbers (page 0 = first page)
      const hasPagination = this.state.pagination;
      let currentPage = 0;

      if (hasPagination) {
        const currentItems = this.state.items.length;
        currentPage = Math.floor(currentItems / pageLimitForKpi);

        // Stop if we've loaded all items
        if (this.state.totalCount && currentItems >= this.state.totalCount) {
          this.setState({
            dataLoading: false,
            pagination: false,
          });
          return;
        }
      }

      if (term) {
        termFilters.push({
          operator: 'and',
          fields: {
            name: { like: term },
          },
        });
        termFilters.push({
          operator: 'and',
          fields: {
            team: {
              operator: 'and',
              fields: {
                description: { like: term },
              },
            },
          },
        });
        const parts = term.split(' ');
        if (parts.length >= 2) {
          termFilters.push({
            operator: 'and',
            fields: {
              owner: {
                operator: 'and',
                fields: {
                  firstname: { like: parts[0] },
                  lastname: { like: parts.slice(1).join(' ') },
                },
              },
            },
          });
          termFilters.push({
            operator: 'and',
            fields: {
              owner: {
                operator: 'and',
                fields: {
                  firstname: { like: parts.slice(1).join(' ') },
                  lastname: { like: parts[0] },
                },
              },
            },
          });
        } else {
          termFilters.push({
            operator: 'and',
            fields: {
              owner: {
                operator: 'or',
                fields: {
                  firstname: { like: term },
                  lastname: { like: term },
                },
              },
            },
          });
        }
      }

      const gqlQuery = `
        query searchKpis($stFilter: SearchFilterInput, $orderBy: [String!], $limit: Int, $page: Int) {
          kpis(stFilter: $stFilter, orderBy: $orderBy, limit: $limit, page: $page) {
            items {
              id
              name
              cadenceDataValue
              precision
              trendColor
              measurementType
              suffix
              status
              updateInterval
              owner {
                id
                firstname
                lastname
              }
              team {
                id
                description
              }
            }
            total
            page
            limit
          }
        }
      `;

      this.setState({ icon_loading: true, dataLoading: true }, () => {
        // Build the filter structure
        let stFilter = null;

        // Build status filter (exclude archived unless checkbox is checked)
        const statusFilter = !this.state.includeArchivedKpis ? {
          operator: 'and',
          fields: {
            status: { eq: 'active' },
          },
        } : null;

        // Combine search filters and status filter
        if (termFilters.length && statusFilter) {
          // Both search terms and status filter
          stFilter = {
            operator: 'and',
            filters: [
              {
                operator: 'or',
                filters: termFilters,
              },
              statusFilter,
            ],
          };
        } else if (termFilters.length) {
          // Only search terms
          stFilter = {
            operator: 'or',
            filters: termFilters,
          };
        } else if (statusFilter) {
          // Only status filter
          stFilter = statusFilter;
        }

        axios({
          method: 'post',
          url: `${wbConfig.baseUrl}/vnext/searchApi/graphql`,
          data: {
            query: gqlQuery,
            variables: {
              stFilter,
              orderBy: ['id asc'],
              limit: pageLimitForKpi,
              page: currentPage,
            },
          },
          headers: { 'Content-Type': 'application/json' },
        })
          .then((res) => {
            const kpisData = res.data?.data?.kpis || {};
            const items = kpisData.items || [];
            const totalCount = kpisData.total ?? items.length;

            // Check if this is the last page by comparing total loaded vs API's total count
            // Don't use items.length < pageLimit because API can return partial pages before the end
            const totalLoadedAfterMerge = this.state.items.length + items.length;
            const isLastPage =
              items.length === 0 ||
              (totalCount > 0 && totalLoadedAfterMerge >= totalCount);

            // Merge with existing items if paginating
            let mergedItems = items;
            if (hasPagination && this.state.items.length > 0) {
              mergedItems = uniqueArrayObject(this.state.items.concat(items), 'id');
            }

            // Filter excluded items
            if (this.props.excludedItems) {
              mergedItems = mergedItems.filter(
                (item) => !this.props.excludedItems.includes(item.id)
              );
            }

            this.setState({
              items: mergedItems,
              totalCount: isLastPage ? mergedItems.length : totalCount,
              dataLoading: false,
              icon_loading: false,
              pagination: false,
            });
          })
          .catch(() => {
            this.setState({
              items: [],
              totalCount: 0,
              dataLoading: false,
              icon_loading: false,
              pagination: false,
            });
          });
      });
      return;
    } else if (type == 'ai') {
      if ((query.q == '' || typeof query.q == 'undefined') && this.state.pagination) {
        this.setState({
          dataLoading: false,
        });
        return;
      }
      if (this.state.aiType !== null) {
        query.type = this.state.aiType;
      }
      url = SEARCH_AI_URL;
    }
    query.limit = pageLimit;
    query.offset = 0;
    if (fromHotbox > 0) {
      if (type == 'ai') {
        if (query.q == '') {
          query.forHotbox = 1;
        }
      } else {
        query.forHotbox = 1;
      }
    }
    if (this.state.pagination) {
      let currentItems = this.state.items.length;
      if (type == 'key_result') {
        // console.log('this.state.items', this.state.items);
        currentItems = this.state.items.reduce((p, c) => {
          let total = p + parseInt(c.metrics.length);
          if (c.metrics.length) {
            c.metrics.map((m) => {
              if (typeof m.nested_krs !== 'undefined' && m.nested_krs.length > 0) {
                total += m.nested_krs.length;
              }
            });
          }
          return total;
        }, 0);
        // console.log('inside');
      }
      // console.log('currentItems', currentItems);
      const totalPage = Math.ceil(this.state.totalCount / pageLimit);
      const currentPage = Math.ceil(currentItems / pageLimit);
      if (currentPage == totalPage || currentItems == this.state.totalCount) {
        this.setState({
          dataLoading: false,
        });
        return;
      }
      query.offset = currentItems;
    }
    const _this = this;
    if (url && (query.q || triggerBackEnd)) {
      if (this.state.closedKr) {
        query.cg = 1;
      }
      if (this.state.includeGreenGoals) {
        query.allKr = 1;
      }
      if (_this.cancelRequest) {
        _this.cancelRequest();
      }
      if (forSubAI) {
        query.tagId = tagId;
        query.parent = parent;
        query.actId = actId;
      }
      url = `${wbConfig.baseUrl}/${url}`;
      axios({
        method: 'get',
        url,
        cancelToken: new CancelToken(function executor(c) {
          _this.cancelRequest = c;
        }),
        params: query,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      }).then((response) => {
        if (response.data) {
          const { data } = response;
          let responseItem = [];
          if (type == 'ai') {
            responseItem = data.ais || [];
          } else if (type == 'key_result') {
            responseItem = data.metrics || [];
          } else if (type == 'objective') {
            responseItem = data.goals || [];
          } else if (type == 'workstream') {
            responseItem = data.ws || [];
          } else if (type == 'kpi') {
            responseItem = data.kpis || [];
          }
          const totalCount = data.totalCount || responseItem.length || 0;
          if (_this.state.pagination) {
            const { items } = _this.state;
            if (type == 'key_result') {
              responseItem.map((item) => {
                const findGoal = items.find((i) => i.goal_id == item.goal_id);
                if (findGoal) {
                  findGoal.metrics = uniqueArrayObject(findGoal.metrics.concat(...item.metrics), 'id');
                } else {
                  items.push(item);
                }
              });
              responseItem = items;
            } else {
              responseItem = uniqueArrayObject(items.concat(...responseItem), 'id');
            }
          }

          if (_this.props.excludedItems) {
            responseItem = responseItem.filter((item) => !_this.props.excludedItems.includes(item.id));
          }

          _this.setState({
            items: responseItem,
            totalCount,
            dataLoading: false,
            icon_loading: false,
          });
        }
      });
    } else {
      this.setState({
        items: props_items,
        totalCount: 0,
      });
    }
  }

  filteredData(item) {
    const type = this.props.id;
    const searchValue = this.state.searchText.trim();
    if (searchValue) {
      if (type == 'last_meeting_actions') {
        const description = item.description.toLowerCase();
        return searchMatchedTextValue(description, searchValue);
      }
    }
    return true;
  }

  addItem(e) {
    // TODO!: nearly all this needs to be moved to action level
    const type = this.props.id;
    const { meetingId = '', fromHotbox = false, rbr = {}, groupId = '' } = this.props;
    const checkedValues = this.state.selectedItems;
    if (checkedValues.length == 0) {
      this.setState({
        errormsg: true,
      });
    } else if (!this.state.isSaving) {
      this.setState(
        {
          errormsg: false,
          isSaving: true,
        },
        () => {
          const params = { items: checkedValues };
          if (Object.keys(rbr).length) {
            params.rbr_id = rbr.id;
            if (groupId) {
              params.groupId = groupId;
            }
          }
          if (fromHotbox) {
            params.fromHotbox = fromHotbox;
          }
          if (meetingId) {
            params.meetingId = meetingId;
          }
          if (type == 'onenote') {
            params['one-note-id'] = $('.selected-one-note-item').data('id');
            params.obj = 'meet';
            params.obj_id = meetingId;
            params.section_id = checkedValues[0];
            this.props.addItem(params);
          } else {
            this.props.addItem(params, this.state.items, e);
            const { searchByTagKRIds } = this.state;
            if (Array.isArray(searchByTagKRIds) && searchByTagKRIds.length && (fromHotbox || type == 'key_result')) {
              const { items, krId, YII_CSRF_TOKEN, ...restParams } = params;
              // console.log('restParams', restParams, items);
              restParams.krId = searchByTagKRIds;
              this.userServices.pushUserEvents({
                source: meetingId ? 'MEETING_SEARCH' : 'RBR_SEARCH',
                data: restParams,
              });
            }
          }
        },
      );
    }
  }

  invertGoals(e, items) {
    this.setState(
      {
        closedKr: !this.state.closedKr,
        pagination: false,
      },
      () => {
        this.callAiSearchApi(true);
      },
    );
  }

  handleGreenGoals(e) {
    this.setState(
      {
        includeGreenGoals: !this.state.includeGreenGoals,
        pagination: false,
      },
      () => {
        this.callAiSearchApi(true);
      },
    );
  }

  handleArchivedKpis(e) {
    this.setState(
      {
        includeArchivedKpis: !this.state.includeArchivedKpis,
        pagination: false,
        items: [], // Clear existing items to start fresh with new filter
        totalCount: 0,
      },
      () => {
        // Only trigger search if there's search text
        if (this.state.searchText) {
          this.callAiSearchApi(true);
        }
      },
    );
  }

  /**
   * Appends items to the end of this.state.items. Input item should be
   * structured correctly for the content to render properly.
   * @param {array} item
   */
  appendItemToState(items) {
    const itemIds = items.map((item) => item.id);
    this.setState({
      items: [...items, ...this.state.items],
      selectedItems: [...itemIds, ...this.state.selectedItems],
    });
    setTimeout(() => this.handleFocusLock(false), 100);
  }

  render() {
    const { t } = this.props;
    const type = this.props.id;
    const modalClass = `meeting-modal-${type}`;
    const title = this.props.name || '';
    const placeholder = this.props.placeholder || '';
    const { items } = this.state;
    const itemsLength = items != undefined ? items.length || 0 : 0;
    const selectedItemsLength = this.state.selectedItems.length || 0;
    const buttonLabel = type == 'last_meeting_actions' ? t('Add to this meeting') : t('Add');
    let transform_property_lm = false;
    const { showGreenCheckbox } = this.props;
    if (type == 'last_meeting_actions') {
      transform_property_lm = true;
    }
    return (
      <Modal
        isFixed
        width={type !== 'last_meeting_actions' ? '52%' : '74%'}
        minHeight="250px"
        maxHeight="550px"
        height="auto"
        id="add-item-modal-objective-kr"
        position={{ x: '50%', y: '50%' }}
        transform_property
        transform_property_lm={transform_property_lm}
        disableFocusLock={this.props.focusLock ? this.state.disableFocusLock : true}
        labelledBy={RELATED_WORK_TITLE}
      >
        <div key={`meet-wbmodal-${type}`} className={`wbmodal ${modalClass}`} style={{ maxHeight: '550px' }}>
          <ModalHeader title={title} closePopup={this.props.closePopup} id={RELATED_WORK_TITLE} />
          <div className="wbmodal-content" style={{ maxHeight: '395px' }}>
            <ModalSearchFilter
              id={this.props.id}
              placeholder={placeholder}
              items={items}
              search={this.search}
              invertGoals={this.invertGoals}
              icon_loading={this.state.icon_loading}
              handleGreenGoals={this.handleGreenGoals}
              includeGreenGoals={this.state.includeGreenGoals}
              showGreenCheckbox={showGreenCheckbox}
              handleArchivedKpis={this.handleArchivedKpis}
              includeArchivedKpis={this.state.includeArchivedKpis}
              errormsg={this.state.errormsg}
              closedKr={this.state.closedKr}
              addNew={this.props.addNew}
              addNewItem={this.appendItemToState}
              handleFocusLock={this.handleFocusLock}
              handleClickOutside={this.handleClickOutside}
              ariaLabel={this.props.ariaLabel}
            />
            <ModalContent
              items={items}
              rowItem={this.rowItem}
              itemsLength={itemsLength}
              ref="scrollDivSection"
              showGreenCheckbox={showGreenCheckbox}
              errormsg={this.state.errormsg}
              dataLoading={this.state.dataLoading}
            />
          </div>
          <ModalFooter
            addItem={this.addItem}
            buttonLabel={this.state.isSaving ? t('Saving...') : buttonLabel}
            closePopup={this.props.closePopup}
            itemsLength={selectedItemsLength}
          />
        </div>
      </Modal>
    );
  }
}

AddITemModal.defaultProps = {
  showGreenCheckbox: false,
};
export default withTranslation()(AddITemModal);
